import i18n from "i18next";
import resourcesToBackend from "i18next-resources-to-backend";
import { DEFAULT_PROFILE_LANGUAGE, normalizeProfileLanguage, PROFILE_LANGUAGES } from "../languages";
import { WEB_LOCALE_LOADERS } from "./loaders";
import { resources as enUS } from "./locales/en-US";

export { WEB_LOCALE_LOADERS } from "./loaders";
export { WEB_NAMESPACE_ROOTS, WEB_NAMESPACES } from "./namespaces";

const WEB_NS = "translation";

const mergeLocale = (pack: Record<string, unknown>): Record<string, unknown> =>
	Object.assign({}, ...Object.values(pack));

const loadLocale = async (lng: string): Promise<Record<string, unknown>> => {
	const locale = normalizeProfileLanguage(lng);
	if (locale === DEFAULT_PROFILE_LANGUAGE) {
		return mergeLocale(enUS);
	}
	const load = WEB_LOCALE_LOADERS[locale as keyof typeof WEB_LOCALE_LOADERS];
	if (!load) {
		return {};
	}
	return mergeLocale((await load()).resources);
};

export const createWebI18n = (plugins: Parameters<typeof i18n.use>[0][] = []) => {
	const instance = i18n.createInstance();
	instance.use(resourcesToBackend((lng: string) => loadLocale(lng)));
	for (const plugin of plugins) {
		instance.use(plugin);
	}
	void instance.init({
		lng: DEFAULT_PROFILE_LANGUAGE,
		fallbackLng: DEFAULT_PROFILE_LANGUAGE,
		supportedLngs: [...PROFILE_LANGUAGES],
		load: "currentOnly",
		ns: [WEB_NS],
		defaultNS: WEB_NS,
		partialBundledLanguages: true,
		initAsync: false,
		resources: { [DEFAULT_PROFILE_LANGUAGE]: { [WEB_NS]: mergeLocale(enUS) } },
		interpolation: { escapeValue: false },
	});
	return instance;
};
